import { Breadcrumbs, Icon, ReportModalLayout } from '@components';
import { routes } from '@constants';
import {
  useNavigateWithOfflineMode,
  useNotifications,
  useScreenSize,
} from '@hooks';
import Net from '@pngs/ActivitiesPage/Net.png';
import { activitiesSlice } from '@store';
import { Button, Flex } from '@styles';
import { ReactComponent as ArrowUp } from '@svgs/expand-less-green.svg';
import { bool, func, node, number } from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  FilterNavigation,
  SideNavigation,
} from 'src/screens/ActivitiesPage/components';

import { activitiesPageLayoutByVariant } from './ActivitiesSideNavTemplate.layoutProps';

const ActivitiesSideNavTemplate = ({
  children,
  isReportModalVisible,
  reportId,
  setReportModalVisible,
}) => {
  const dispatch = useDispatch();
  const { navigate } = useNavigateWithOfflineMode();
  const { device, isTabletLG } = useScreenSize();
  const layout = activitiesPageLayoutByVariant[device || 'desktop'];

  const [scrollPosition, setScrollPosition] = useState(0);

  const { notifications, refetchNotifications } = useNotifications();
  const { activitiesSideContentState } = useSelector(
    (state) => state.activitiesSlice
  );

  const handleScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop;

    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight;

    setScrollPosition(winScroll / height);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    refetchNotifications();
  }, [activitiesSideContentState]);

  const checkNotifications = (type) => {
    switch (type) {
      case 'additional':
        return notifications?.scenario || notifications?.extra_test;
      default:
        return notifications?.[type];
    }
  };

  const handleNavigationButtonClick = (navigationButtonState) => () => {
    // TO DO: add another source
    if (navigationButtonState === 'seeMore') {
      window.open('https://www.armedconflict.law/mediaCenter', '_blank');
      return;
    }
    dispatch(
      activitiesSlice.actions.setActivitiesSideContentState(
        navigationButtonState
      )
    );

    navigate(routes.activities);
  };

  const scrollToTop = () =>
    window.scrollTo({ behavior: 'smooth', left: 0, top: 0 });

  return (
    <Flex flexDirection="column">
      <ReportModalLayout
        activityId={reportId}
        isVisible={isReportModalVisible}
        setIsVisible={setReportModalVisible}
        withBackdropNoise
      />
      <Breadcrumbs containerProps={{ px: layout?.px }} />
      <Flex
        backgroundImage={Net}
        backgroundPosition="left 0 top -205px"
        backgroundRepeat="no-repeat"
        flexDirection="row"
        height="100%"
        pt={24}
        px={layout?.px}
      >
        {scrollPosition >= 0.1 && (
          <Button
            borderRadius={4}
            bottom={isTabletLG ? 114 : layout.px / 2}
            height={48}
            onClick={scrollToTop}
            position="fixed"
            right={isTabletLG ? 16 : layout.px / 2}
            variant="primary"
            width={48}
            zIndex={2}
          >
            <Icon height="100%" SVG={ArrowUp} width="100%" />
          </Button>
        )}
        {isTabletLG ? (
          <FilterNavigation
            checkNotifications={checkNotifications}
            onNavigationButtonClick={handleNavigationButtonClick}
          />
        ) : (
          <SideNavigation
            checkNotifications={checkNotifications}
            onNavigationButtonClick={handleNavigationButtonClick}
          />
        )}
        {children}
      </Flex>
    </Flex>
  );
};

ActivitiesSideNavTemplate.propTypes = {
  children: node.isRequired,
  isReportModalVisible: bool,
  reportId: number,
  setReportModalVisible: func,
};

ActivitiesSideNavTemplate.defaultProps = {
  isReportModalVisible: false,
  reportId: null,
  setReportModalVisible: () => {},
};

export default ActivitiesSideNavTemplate;
